import { React, useState } from 'react';
import styled from 'styled-components';

export default function RefundReasonInput(props) {
  const { value, setValue, placeholder} = props;

	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {

	}

  return(
    <TopLevelWrapper>
      <Input
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const Input = styled.textarea`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

	padding: 10px;

	width: calc(100% - 22px);
	height: 21px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;

  font-fmaily: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 20.27px;

	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  resize: none;
	outline: none;

  &::placeholder {
		color: ${props => props.theme.subText};
    font-fmaily: NotoSansKR-Regular;
    font-size: 14px;
	}
`;
